import Index, { IndexProps } from '@quiz-frontend/quiz-builder/pages';
import { saveResults } from '@quiz-frontend/quiz-builder/store/quiz/thunks';
import { connect } from 'react-redux';

export default connect<null, IndexProps, null>(null, { onComplete: saveResults })(Index);
